import { useSelector, useDispatch } from "react-redux";

const useDesings = () => {
  const dispatch = useDispatch();
  const { data } = useSelector(state => state.processDesings);

  const saveData = desing => {
    dispatch({ type: "ADD_PROCESS_DESING", desing });
  };

  const updateData = desing => {
    dispatch({ type: "UPDATE_PROCESS_DESING", desing });
  };

  return { processDesings: data, saveData: saveData, updateData: updateData };
};

export default useDesings;
